export const getFileName = (key?: string) => {
	if (!key) return '-';
	return key.split('/').pop() ?? '-';
};

export const getFileType = (fileName?: string) => {
	if (!fileName) return '-';
	return fileName.split('.').pop()?.toUpperCase() ?? '-';
};

export const formatFileType = (ext?: string) => {
	if (!ext) return '-';

	const map: Record<string, string> = {
		PDF: 'PDF Document',
		JPG: 'JPEG Image',
		JPEG: 'JPEG Image',
		PNG: 'PNG Image',
		GIF: 'GIF Image',
		MP4: 'Video',
		MOV: 'Video',
		DOC: 'Word Document',
		DOCX: 'Word Document',
	};

	return map[ext] ?? `${ext} File`;
};

export const formatFileSize = (bytes?: number) => {
	if (!bytes && bytes !== 0) return '-';

	const kb = bytes / 1024;
	const mb = bytes / (1024 * 1024);

	if (mb >= 1) {
		return `${mb.toFixed(2)} MB`;
	}

	return `${kb.toFixed(2)} KB`;
};

export const SCAN_STATUS_CONTENT: Record<string, { title: string; info: string; cardTitle?: string }> = {
	ThreatsFound: {
		title: 'File Blocked',
		cardTitle: 'This file is unavailable due to security restrictions.',
		info: 'This file did not pass security checks and was blocked to protect your device. Potential threats were detected during scanning.',
	},
	NoThreatsFound: {
		title: 'View uploaded file',
		info: 'For security and privacy reasons, this link may expire or be limited to authorized workspace users only.',
	},
	UnsupportedFileType: {
		title: 'File type not supported',
		cardTitle: 'This file is unavailable to download',
		info: 'This file type cannot be scanned. Please ensure the file format is supported by the system.',
	},
	FailedToScan: {
		title: 'Scan failed',
		cardTitle: 'This file is unavailable to download',
		info: 'We were unable to complete the security scan. Please try uploading the file again or contact support if the issue persists.',
	},
	Pending: {
		title: 'Scan in progress',
		cardTitle: 'This file is unavailable to download',
		info: 'The file is currently being scanned. Access may be limited until the scan is complete.',
	},
	Unknown: {
		title: 'Scan status unavailable',
		cardTitle: 'This file is unavailable to download',
		info: 'The system could not determine the scan result for this file. Please try again later or contact support if needed.',
	},
};

export const text = {
	aside: {
		tag: 'Secure access',
		title: 'Your file is ready',
		p: 'This file was uploaded through a Storycards form submission. Review the details and download it securely.',
		note: 'Access to uploaded files may be restricted based on workspace permissions and link validity.',
	},
	hero: {
		subtitle:
			"This file was submitted by a user through your Storycards form. You can preview the file details below and download it when you're ready.",
		topCardNote: 'Uploaded through a Storycards form submission and ready for secure download.',
		topCardBtn: 'Ready to download',
		downloadBtn: 'Download file',
		homeBtn: 'Back to Storycards',
		note: 'If the file is unavailable, expired, or restricted, please contact your workspace administrator.',
	},
	issues: {
		asideTitle: 'File is no longer available.',
		deletedTitle: 'File deleted',
		deletedCardTitle: 'This file has been deleted.',
		deletedInfo:
			'The file was removed and is no longer accessible. It may have been deleted by someone in your workspace.',
	},
};
